import { ShutdownTime } from './components';
import { SideBarDialog } from 'shared/components';

import { useTurnOffCustomization } from './hooks';

import makeClasses from './TurnOffProduct.style';

import type {
  IMenuCustomization,
  ITurnOffItemTime,
} from 'features/menu-page/domain';

export function TurnOffCustomization(props: Props) {
  const { customization, cancelCTA, turnOffCTA } = props;
  const hasCustom = customization !== null;
  if (!hasCustom) return null;

  const {
    lang,
    status,
    handleShutdownTimeOpt,
    handleShutdownCustomDate,
    handleCallToAction,
  } = useTurnOffCustomization({ turnOffCTA });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      size='small'
      open={hasCustom}
      onClose={cancelCTA}
      headerTitle={lang.title}
      posNav={
        <div className={_classes.info}>
          <p aria-label='info-name'>{customization?.description}</p>
        </div>
      }
      actions={{
        primaryBtn: {
          children: lang.action.primaryBtn,
          disabled: status.disabled,
          onClick: handleCallToAction,
        },
      }}
    >
      <ShutdownTime
        customDate={status.customDate}
        onChange={handleShutdownTimeOpt}
        onAcceptCustomDate={handleShutdownCustomDate}
      />
    </SideBarDialog>
  );
}

interface Props {
  customization: IMenuCustomization | null;
  cancelCTA: () => void;
  turnOffCTA: (p: ITurnOffItemTime) => void;
}
